"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const asyncComponent = loader => {
  class AsyncComponent extends _react.Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillMount() {
      const load = loader();
      load.then(C => {
        this.setState({
          component: C
        });
      }).catch(console.error); // eslint-disable-line
    }

    render() {
      const {
        component
      } = this.state;
      return component ? /*#__PURE__*/_react.default.createElement(component.default, this.props) : null;
    }
  }
  return AsyncComponent;
};
var _default = asyncComponent;
exports.default = _default;